// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Notify from "@flip/App/Components/Notify";
import { SectionContainer, SectionTitle } from "@flip/App/Widgets/DesignSystem/DesignSystem.helpers";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import GridItem from "@insite/mobius/GridItem";
import React, { FC } from "react";

const NotifyTab: FC = props => {
    return (
        <SectionContainer extendedStyles={{ gridContainer: { gap: 8 } }}>
            <GridItem width={12}>
                <SectionTitle>Notify</SectionTitle>
            </GridItem>
            <GridItem width={12}>
                <Notify type="warning">{siteMessage("Warning Notification: Additional Copy Goes Here")}</Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="info">{siteMessage("Info Notification: Additional Copy Goes Here")}</Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="danger">{siteMessage("Danger Notification: Additional Copy Goes Here")}</Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="success">{translate("Success Notification: Additional Copy Goes Here")}</Notify>
            </GridItem>
        </SectionContainer>
    );
};

export default NotifyTab;
